// extracted by mini-css-extract-plugin
export default {"main":"InvitesActionCell_main__l27pC","actions":"InvitesActionCell_actions__A5x+H","actions__content":"InvitesActionCell_actions__content__OlMb2"};